/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const ONBOARDING_STEPS = ['language', 'daily-reminder'] as const;

export const onboardingStepSchema = z.enum(ONBOARDING_STEPS);

export type IOnboardingStep = z.infer<typeof onboardingStepSchema>;
